import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import type { Schedule } from '@/lib/api/types/schedules';
import { getSchedulesByItemIds } from '@/lib/api/work-integrations/schedules';
import { workIntegrationsQueryKeys } from '@/lib/query-keys/work-integrations';

export const useGetSchedulesByItemIds = (
  itemIds: number[],
  staleTime?: number,
  enabled: boolean = true,
) => {
  const allItemIdsSet = useMemo(() => new Set(itemIds), [itemIds]);

  return useQuery<Record<number, Schedule>, Error>({
    queryKey: workIntegrationsQueryKeys.schedules({ itemIds: allItemIdsSet }),
    queryFn: () => getSchedulesByItemIds(allItemIdsSet),
    enabled: enabled && itemIds.length > 0,
    placeholderData: (previousData) => previousData,
    ...(staleTime !== undefined && { staleTime }),
  });
};
